<script>
  import { AB_CONTENT, AB_SUBJECT, REGULAR, WIN_TYPE_CLICK, WIN_TYPE_OPEN } from "./static";
  import Slider from "../Common/Slider.svelte";
  import {M} from "../external";

  export let data, next;

  let onNext = () => {
    next();
  };

  $: {
    if (!data.type) data.type = REGULAR;
    if (data.type !== REGULAR && !data.data) data.data = {};
    if (data.data && !data.data.winType) data.data.winType = WIN_TYPE_OPEN;
    if (!!data.data && data.data.winnerDelay === -1) data.data.winnerDelay = 12;
    if (data.type === AB_CONTENT) data.data.winType = WIN_TYPE_CLICK;
  }
</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper">
          <div class="flex-centered f-left booking-buttons-wrapper none">
            <div>
              <h1 class="members-title f-left mb-0">{M.SYSTEM_EMAILS}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15"><span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> border_all </span></div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.CAMPAIGN_TYPE}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.CAMPAIGN_TYPE_PICK}</div>
            <div class="col20 flex f-left t-center justify-center">
              <a class="addon-select half-select" class:selected={data.type === REGULAR} on:click={() => (data.type = REGULAR)} style="max-width: 300px;">
                <img alt="" class="mt-15" src="https://static.simvoly.com/images/regular-campaign.png" />
                <h4 class="col20 f-left mt-25">{M.REGULAR_CAMPAIGN}</h4>
                <span class="col20 f-left t-center light-gray-text">{M.REGULAR_CAMPAIGN_DESC}</span>
              </a>
              <a
                class="addon-select half-select"
                class:selected={data.type === AB_CONTENT || data.type === AB_SUBJECT}
                on:click={() => (data.type = AB_SUBJECT)}
                style="max-width: 300px;">
                <img alt class="mt-15" src="https://static.simvoly.com/images/ab-campaign.png" />
                <h4 class="col20 f-left mt-25">{M.AB_SPLIT_CAMPAIGN}</h4>
                <span class="col20 f-left t-center light-gray-text">{M.AB_SPLIT_CAMPAIGN_DESC}</span>
              </a>
            </div>
            {#if data.type === AB_CONTENT || data.type === AB_SUBJECT}
              <h2 class="col20 f-left t-center mt-25" style="font-size: 21px;">{M.SPLIT_TEST_QST}</h2>
              <div class="col20 flex f-left t-center mt-15 justify-center">
                <a
                  class="addon-select half-select flex flex-col justify-center"
                  class:selected={data.type === AB_SUBJECT}
                  on:click={() => (data.type = AB_SUBJECT)}
                  style="max-width: 200px;">
                  <h4 class="col20 f-left">{M.EMAIL_SUBJECT}</h4>
                  <span class="col20 f-left t-center light-gray-text">{M.EMAIL_SUBJECT_TEST_DESC}</span>
                </a>
                <a
                  class="addon-select half-select flex flex-col justify-center"
                  class:selected={data.type === AB_CONTENT}
                  on:click={() => (data.type = AB_CONTENT)}
                  style="max-width: 200px;">
                  <h4 class="col20 f-left">{M.EMAIL_CONTENT}</h4>
                  <span class="col20 f-left t-center light-gray-text">{M.EMAIL_CONTENT_DESC}</span>
                </a>
              </div>
              <h2 class="col20 f-left t-center mt-25" style="font-size: 21px;">{M.WINNER_BASE}</h2>
              <div class="col20 flex f-left t-center mt-15 justify-center">
                {#if data.type !== AB_CONTENT}
                  <a
                    class="addon-select half-select flex flex-col justify-center"
                    class:selected={data.data.winType === WIN_TYPE_OPEN}
                    on:click={() => (data.data.winType = WIN_TYPE_OPEN)}
                    style="max-width: 200px;">
                    <h4 class="col20 f-left">{M.OPEN_RATE}</h4>
                    <span class="col20 f-left t-center light-gray-text">{M.OPEN_RATE_DESC}</span>
                  </a>
                {/if}
                <a
                  class="addon-select half-select flex flex-col justify-center"
                  class:selected={data.data.winType === WIN_TYPE_CLICK}
                  on:click={() => (data.data.winType = WIN_TYPE_CLICK)}
                  style="max-width: 200px;">
                  <h4 class="col20 f-left">{M.CLICK_RATE}</h4>
                  <span class="col20 f-left t-center light-gray-text">{M.CLICK_RATE_DESC}</span>
                </a>
              </div>
              <h2 class="col20 f-left t-center mt-25" style="font-size: 21px;">{M.WINNER_DESCIDER}</h2>
              <Slider step={1} min={1} max={24} bind:value={data.data.winnerDelay} sameLine={true} showValue={true} suffix="h" clz="mt-5 email-slider" />
            {/if}
            <div class="col20 f-left flex justify-center mt-35 mb-35">
              <a data-action="nextPage" on:click={onNext} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">{M.NEXT} →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
